// extracted by mini-css-extract-plugin
module.exports = {"text":"MenuShareMerch_text__6VNQi","menuArea":"MenuShareMerch_menuArea__gPxkT","menuItem":"MenuShareMerch_menuItem__dG53I","iconContainer":"MenuShareMerch_iconContainer__6QnEH"};